import { toastr } from "react-redux-toastr";
import { FAV_ACTION_TYPES } from "./actionTypes";
import { selectIsItemFavorite } from "./selectors";

export const favActions = {
    toggleItem: (product) => ({
        type: FAV_ACTION_TYPES.TOGGLE_ITEM,
        payload: product,
    }),
    clearFavorites: () => ({
        type: FAV_ACTION_TYPES.CLEAR_FAVORITES,
    }),
};

export const toggleFavorite = (product) => (dispatch, getState) => {
    if (!product || !product.id) return;

    const isAlreadyFavorite = selectIsItemFavorite(getState(), product.id);

    dispatch(favActions.toggleItem(product));

    if (isAlreadyFavorite) {
        toastr.info('Избранное', `Товар "${product.name}" удален из избранного.`);
    } else {
        toastr.success('Избранное', `Товар "${product.name}" добавлен в избранное.`);
    }
};